import React from "react";
import { useNavigate } from "react-router-dom";
import { CalendarDays, Coins, BarChart3, UserRound } from "lucide-react";
import { fmtEUR } from "../../../lib/api";
import { Delta } from "./ui";

const Kpi = ({ icon: Icon, label, value, delta, hint, onClick, testid }) => (
  <button type="button" onClick={onClick} data-testid={testid} className="nx-card px-3 sm:px-4 py-3.5 flex items-center gap-3.5 text-left hover:border-[#D4A72C]/40 transition-colors min-w-0">
    <span className="hidden sm:flex w-12 h-12 rounded-xl bg-[#0F1A2E] border border-white/10 items-center justify-center shrink-0"><Icon size={22} className="text-slate-100" strokeWidth={1.6} /></span>
    <span className="min-w-0">
      <span className="block text-[12px] text-slate-300">{label}</span>
      <span className="flex flex-wrap items-baseline gap-x-2 mt-0.5"><span className="text-[20px] sm:text-[26px] leading-none font-semibold text-white font-mono-num whitespace-nowrap" data-testid={`${testid}-value`}>{value}</span>{delta}</span>
      <span className="block text-[10.5px] text-slate-500 mt-1 truncate">{hint}</span>
    </span>
  </button>
);

export function KpiRow({ k, weather }) {
  const nav = useNavigate();
  const now = new Date();
  return (
    <div className="grid grid-cols-2 xl:grid-cols-5 gap-3" data-testid="nx-kpis">
      <Kpi icon={CalendarDays} label="Servizi oggi" value={k?.services_today ?? "—"} testid="nx-kpi-services" onClick={() => nav("/prenotazioni")}
        delta={<Delta cur={k?.services_today} prev={k?.services_last_week} />} hint="Rispetto alla settimana precedente" />
      <Kpi icon={Coins} label="Fatturato mese" value={k ? fmtEUR(k.revenue_month) : "—"} testid="nx-kpi-revenue" onClick={() => nav("/conteggi")}
        delta={<Delta cur={k?.revenue_month} prev={k?.revenue_prev} />} hint="Rispetto al mese precedente" />
      <Kpi icon={BarChart3} label="Margine operativo" value={k?.margin_pct != null ? `${Math.round(k.margin_pct)}%` : "N/D"} testid="nx-kpi-margin" onClick={() => nav("/conteggi")}
        delta={<Delta cur={k?.margin_pct} prev={k?.margin_pct_prev} points />} hint="Margine / fatturato, mese corrente" />
      <Kpi icon={UserRound} label="Clienti attivi" value={k?.clients_month ?? "—"} testid="nx-kpi-clients" onClick={() => nav("/clienti")}
        delta={<Delta cur={k?.clients_month} prev={k?.clients_prev} />} hint="Con servizi nel mese, vs mese prec." />
      <div className="nx-card px-4 py-3.5 col-span-2 xl:col-span-1 flex items-center justify-between gap-3" data-testid="nx-date-card">
        <div>
          <div className="text-[13px] text-slate-300 capitalize">{now.toLocaleDateString("it-IT", { weekday: "long" })}</div>
          <div className="text-[19px] text-white font-semibold leading-tight">{now.toLocaleDateString("it-IT", { day: "numeric", month: "long", year: "numeric" })}</div>
          <div className="text-[19px] text-white font-mono-num">{now.toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" })}</div>
        </div>
        {weather?.temperature != null && <div className="text-right" data-testid="nx-weather"><div className="text-xl text-[#E9C46A] font-mono-num">{weather.temperature}°C</div><div className="text-[10px] text-slate-400 max-w-[90px]">{weather.condition}</div></div>}
      </div>
    </div>
  );
}
